module.exports = __webpack_public_path__ + "img/tt-6.59085292.png";